module.exports = __webpack_public_path__ + "static/media/sequence-keyword.8311efc6.svg";